import { IAssetOwnerState } from '@/modules/assetOwner/store/state';
import { MutationTree } from 'vuex';
import { TimePeriod } from '@/modules/fund/types';
import * as MT from '@/modules/assetOwner/store/mutationsTypes';
import { AllAnalysisData } from '@/modules/costAnalysis/types';
import { PensionScheme } from '../types';

/*--------------------------------------------------/
 * Asset Owner Mutations
 *--------------------------------------------------*/
export const AssetOwnerMutations: IAssetOwnerMutations = {
  [MT.SET_ROOT_INVESTMENT_ID]: (
    state: IAssetOwnerState,
    rootInvestmentId: string
  ) => (state.rootInvestmentId = rootInvestmentId),

  [MT.SET_SELECTED_TIME_PERIOD]: (
    state: IAssetOwnerState,
    timePeriod: TimePeriod
  ) => (state.selectedTimePeriod = timePeriod),

  [MT.SET_SCHEME_COST_ANALYSIS_DETAILS]: (
    state: IAssetOwnerState,
    costAnalysisDetails: AllAnalysisData
  ) => (state.costAnalysisDetails = costAnalysisDetails),

  [MT.SET_ENTITY_ROOT_INVESTMENTS]: (
    state: IAssetOwnerState,
    entityRootInvestments: PensionScheme[]
  ) => (state.entityRootInvestments = entityRootInvestments),

  [MT.SET_ENTITY_ROOT_INVESTMENT_IDS]: (
    state: IAssetOwnerState,
    rootInvestmentIds: string[]
  ) => (state.entityRootInvestmentIds = rootInvestmentIds)
};

/*--------------------------------------------------/
 * Asset Owner Mutations Tree Interface
 *--------------------------------------------------*/
export interface IAssetOwnerMutations extends MutationTree<IAssetOwnerState> {
  [MT.SET_ROOT_INVESTMENT_ID](
    state: IAssetOwnerState,
    rootInvestmentId: string
  ): void;

  [MT.SET_SELECTED_TIME_PERIOD](
    state: IAssetOwnerState,
    timePeriod: TimePeriod
  ): void;

  [MT.SET_SCHEME_COST_ANALYSIS_DETAILS](
    state: IAssetOwnerState,
    costAnalysisDetails: AllAnalysisData
  ): void;
}
